import { useState, useEffect } from "react"
import { useNavigate, Link, useLocation } from "react-router-dom"
import { Button } from "react-bootstrap"
import Select from "react-select"
import Loader from "../Common/Loader"
import { createScriptAction, editScriptAction } from "../../../store/actions/ScriptAction"
import { handleError } from "../../../services/ErrorHandlingService"
import { useSelector, useDispatch } from "react-redux"
import { getDiseasesAction } from "../../../store/actions/DiseasesAction"
import { FaMicrophone } from "react-icons/fa";
import { useRef } from "react";


const AddScript = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { item } = location.state || {}
  const diseases = useSelector((state) => state.diseases?.diseases || [])
  const isEditMode = !!item
  const [scriptType, setScriptType] = useState(null);

  const [selectedDiseases, setSelectedDiseases] = useState([])
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(true);
  const [scriptText, setScriptText] = useState("")
  const scriptTypeOptions = [
    { value: "Service Call", label: "Service Call" },
    { value: "Telecaller", label: "Telecaller" },
  ];

  const recognitionRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [speechLang, setSpeechLang] = useState("en-IN");

  const toggleLanguage = () => {
    setSpeechLang((prev) => (prev === "en-IN" ? "mr-IN" : "en-IN"));
  };

  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Speech Recognition not supported in this browser");
      return;
    }

    if (recognitionRef.current) return; // already recording

    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;

    recognition.lang = speechLang;
    recognition.continuous = false;
    recognition.interimResults = false;

    setIsRecording(true);

    recognition.onresult = (event) => {
      const spokenText = event.results[0][0].transcript;

      setScriptText((prev) => {
        const nextValue = prev ? prev + " " + spokenText : spokenText
        clearFieldError("script_text")
        return nextValue
      });
    };

    recognition.onend = () => {
      setIsRecording(false);
      recognitionRef.current = null;
    };

    recognition.onerror = () => {
      setIsRecording(false);
      recognitionRef.current = null;
    };

    recognition.start();
  };

  useEffect(() => {
    dispatch(getDiseasesAction(false)).then(() => {
      setFetching(false);
    });
  }, [dispatch]);

  useEffect(() => {
    if (isEditMode && item) {
  
      // IMPORTANT: handle nested data
      const scriptData = item.data || item;
  
      console.log("Edit Script Data:", scriptData);
  
      setScriptText(scriptData.script_text || "");
  
      // Diseases
      if (Array.isArray(scriptData.diseases)) {
        const mappedDiseases = scriptData.diseases.map((d) => ({
          value: String(d.disease_id),
          label: d.disease_name,
        }));
        setSelectedDiseases(mappedDiseases);
      }
  
      // Script Type
      if (scriptData.script_type) {
        const matchedType = scriptTypeOptions.find(
          (opt) =>
            opt.value.toLowerCase().trim() ===
            scriptData.script_type.toLowerCase().trim()
        );
  
        setScriptType(matchedType || null);
      }
    }
  }, [isEditMode, item]);
  console.log("Edit Item:", item);

  


  const validateForm = () => {
    const newErrors = {}

    if (!scriptText.trim()) {
      newErrors.script_text = "Script is required"
    }

    if (!selectedDiseases.length) {
      newErrors.diseases = "Please select at least one disease"
    }

    if (!scriptType) {
      newErrors.script_type = "Please select script type";
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev
      const { [field]: _removed, ...rest } = prev
      return rest
    })
  }

  const handleScriptTextChange = (value) => {
    setScriptText(value)
    clearFieldError("script_text")
  }

  const handleScriptTypeChange = (selectedOption) => {
    setScriptType(selectedOption)
    clearFieldError("script_type")
  }

  const handleDiseaseChange = (selectedOptions) => {
    setSelectedDiseases(selectedOptions)
    clearFieldError("diseases")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return
    setLoading(true)

    const scriptData = {
      script_id: isEditMode ? item.script_id || item.id : undefined,
      script_text: scriptText,
      disease_ids: selectedDiseases?.map((d) => d.value).join("|") || "",
      script_type: scriptType?.value || "",
    }

    try {
      const result = await dispatch(isEditMode ? editScriptAction(scriptData) : createScriptAction(scriptData))
      if (result?.success) {
        navigate("/scripts")
      }
    } catch (err) {
      console.error(`${isEditMode ? "Update" : "Create"} failed:`, err)
    } finally {
      setLoading(false)
    }
  }

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    )
  }
  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end mb-3">
          <Link to="/scripts" className="btn btn-link">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-12 mb-3">
                  <label htmlFor="script_text" className="form-label">
                    Script <span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="position-relative">
                    <textarea
                      className="form-control pe-5"
                      id="script_text"
                      rows="6"
                      placeholder="Enter Script"
                      value={scriptText}
                      onChange={(e) => handleScriptTextChange(e.target.value)}
                      style={{
                        padding: "0.375rem 0.75rem",
                        paddingTop: "0.6rem",
                        paddingBottom: "40px",
                      }}
                    />

                    {/* 🎙 MIC BUTTON */}
                    <button
                      type="button"
                      onClick={startListening}
                      disabled={isRecording}
                      style={{
                        position: "absolute",
                        right: "20px",
                        bottom: "10px",
                        width: "34px",
                        height: "34px",
                        borderRadius: "50%",
                        border: "none",
                        background: isRecording ? "#ff4d4d" : "#f1f3f5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: isRecording
                          ? "0 0 10px 3px rgba(255,0,0,0.6)"
                          : "0 2px 4px rgba(0,0,0,0.12)",
                        cursor: "pointer",
                      }}
                    >
                      <FaMicrophone size={15} color={isRecording ? "white" : "#333"} />
                    </button>

                    {/* 🌐 Language toggle (optional) */}
                    <button
                      type="button"
                      onClick={toggleLanguage}
                      style={{
                        position: "absolute",
                        right: "60px",
                        bottom: "10px",
                        padding: "2px 10px",
                        borderRadius: "12px",
                        border: "1px solid #ccc",
                        background: "#fff",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      {speechLang === "en-IN" ? "EN" : "MR"}
                    </button>
                  </div>

                  {errors.script_text && (
                    <div className="text-danger mt-1">{errors.script_text}</div>
                  )}
                </div>


                {/* <div className="col-xl-12 mb-3">
                  <label className="form-label">Disease</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    isMulti
                    name="diseases"
                    options={diseases.map((d) => ({
                      value: String(d.disease_id),
                      label: d.disease_name,
                    }))}
                    value={selectedDiseases}
                    onChange={handleDiseaseChange}
                    placeholder="Select Disease(s)"
                    styles={{
                      control: (provided) => ({ ...provided, minHeight: "55px" }),
                      multiValue: (provided) => ({ ...provided, backgroundColor: "#e0e0e0" }),
                    }}
                  />
                  {errors.diseases && <div className="text-danger mt-1">{errors.diseases}</div>}
                </div> */}
                <div className="row">
                  {/* Disease Select */}
                  <div className="col-xl-6 mb-3">
                    <label className="form-label">Disease</label>
                    <span style={{ color: "red" }}>*</span>

                    <Select
  isMulti
  name="diseases"
  options={diseases.map((d) => ({
    value: String(d.disease_id),
    label: d.disease_name,
  }))}
  value={selectedDiseases}
  onChange={handleDiseaseChange}
  placeholder="Select Disease(s)"
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    control: (provided) => ({
      ...provided,
      minHeight: "50px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e0e0e0",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // VERY IMPORTANT
    }),
  }}
/>



                    {errors.diseases && (
                      <div className="text-danger mt-1">{errors.diseases}</div>
                    )}
                  </div>

                  {/* Script Type Dropdown */}
                  <div className="col-xl-6 mb-3">
                    <label className="form-label">Script For</label>
                    <span style={{ color: "red" }}>*</span>

                    <Select
                      name="script_type"
                      options={scriptTypeOptions}
                      value={scriptType}
                      onChange={handleScriptTypeChange}
                      placeholder="Select Script Type"
                      styles={{
                        control: (provided) => ({ ...provided, minHeight: "50px" }),
                      }}
                    />

                    {errors.script_type && (
                      <div className="text-danger mt-1">{errors.script_type}</div>
                    )}
                  </div>
                </div>

              </div>

              <button type="submit" className="btn btn-primary" disabled={loading || fetching}>
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">{isEditMode ? "Updating..." : "Submitting..."}</span>
                  </>
                ) : (
                  <>{isEditMode ? "Update Script" : "Add Script"}</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddScript